import React,{useContext} from 'react';

import {ContextPlayer} from '../player/PlayerProvider';
import {ContextGlobal} from '../../globalProvider';

import {parseTimeToString} from '../../Utils';
import './Score.css';

const Score = () =>{

	const player = useContext(ContextPlayer);
	const global = useContext(ContextGlobal); 
	// Css control of the component visualisation in diffents devices
	 const styleDisplay = (!global.state.isMobile)?{position:"inherit"}:
		 (player.state.initGame)?{position:"inherit"}:{position:"fixed", left:"110vw"};
		 
	return (
		<div className="panelScore backgroundEIC2 centerText " style={styleDisplay} >
 			{parseTimeToString(player.state.timeout)} | {(player.state.moves < 10)?"0"+player.state.moves:player.state.moves}
 		</div>
	);
}

export default Score;